import styles from './BrandPanel.module.css';
import InfoCard from './InfoCard';
import { Headset, Timer, ShieldCheck } from 'lucide-react';
import T from '../T';
import LanguageSwitcher from '../LanguageSwitcher';

const BrandPanel = () => {
  return (
    <div className={styles.panel}>
      {/* Decorative Orbs */}
      <div className={`${styles.orb} ${styles.orbTop}`} />
      <div className={`${styles.orb} ${styles.orbBottom}`} />

      <div className={styles.content}>
        {/* Brand Logo and Language Switcher */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <div className={styles.logoRow} style={{ marginBottom: 0 }}>
            <div className={styles.logoSquare}>
              <Headset size={16} color="#0d1b3e" strokeWidth={2.5} />
            </div>
            <span className={styles.logoText}><T>Autochek Tech Support</T></span>
          </div>
          <LanguageSwitcher variant="light" />
        </div>

        {/* Portal Badge */}
        <div className={styles.badge}>
          <div className={styles.pulseDot} />
          <span><T>Staff portal</T></span>
        </div>

        {/* Main Heading */}
        <h1 className={styles.heading}>
          <T>Welcome back</T> <T>to our workspace</T>.
        </h1>

        <p className={styles.subtitle}>
          <T>Raise a request, report an incident, or get access to the tools you need — all in one place</T>.
        </p>

        {/* Info Cards */}
        <div className={styles.infoRow}>
          <InfoCard 
            icon={<Timer size={14} />} 
            text={<T>~2h response time</T>} 
          />
          <InfoCard 
            icon={<ShieldCheck size={14} />} 
            text={<T>Secure staff access</T>} 
          />
        </div>
      </div>

      <div className={styles.copyright}>
        © {new Date().getFullYear()} Autochek Tech. <T>All rights reserved</T>.
      </div>
    </div>
  );
};

export default BrandPanel;
